var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "top-btn" },
      [
        _c(
          "vxe-button",
          { attrs: { status: "success" }, on: { click: _vm.returnToLevel } },
          [_vm._v("返回")]
        ),
      ],
      1
    ),
    _c("table", { attrs: { loading: _vm.listLoading } }, [
      _c("tr", [
        _c("th", [_vm._v("申请单位")]),
        _c("td", [_vm._v(_vm._s(_vm.form.org_id))]),
        _c("td", { attrs: { colspan: "3" } }, [
          _vm._v("申请时间：" + _vm._s(_vm.form.cdate)),
        ]),
      ]),
      _c("tr", [
        _c("th", [_vm._v("活动类型")]),
        _c("td", { staticClass: "align-right" }, [_vm._v(" 类型： ")]),
        _c("td", { attrs: { colspan: "3" } }, [
          _vm._v(_vm._s(_vm.form.hd_type)),
        ]),
      ]),
      _c("tr", [
        _c("th", { attrs: { rowspan: "3" } }, [_vm._v("活动时间、地点")]),
        _vm._m(0),
        _c("td", { attrs: { colspan: "3" } }, [
          _vm._v(_vm._s(_vm.form.hd_begin_time) + " "),
          _c("span", { staticStyle: { color: "red" } }, [_vm._v("至")]),
          _vm._v(" " + _vm._s(_vm.form.hd_end_time)),
        ]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [_vm._v(" 地点： ")]),
        _c("td", { attrs: { colspan: "3" } }, [
          _vm._v(_vm._s(_vm.form.hd_address)),
        ]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [_vm._v(" 详细地址： ")]),
        _c("td", { attrs: { colspan: "3" } }, [
          _vm._v(_vm._s(_vm.form.dtl_address)),
        ]),
      ]),
      _c("tr", [
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("二网活动")]),
        _c("td", { staticClass: "align-right" }, [_vm._v("是否二网活动：")]),
        _c("td", { attrs: { colspan: "3" } }, [
          _vm._v(_vm._s(_vm.form.online_stores)),
        ]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [_vm._v("二网名称：")]),
        _c("td", { attrs: { colspan: "3" } }, [
          _vm._v(_vm._s(_vm.form.ewd_address)),
        ]),
      ]),
      _c("tr", [
        _c("th", [_vm._v("窝子户")]),
        _c("td", { staticClass: "align-right" }, [_vm._v("客户窝子：")]),
        _c("td", { attrs: { colspan: "3" } }, [
          _vm._v(_vm._s(_vm.form.household_name)),
        ]),
      ]),
      _c("tr", [
        _c("th", [_vm._v("用户数量")]),
        _c("td", { staticClass: "align-right" }, [_vm._v("用户数量：")]),
        _c("td", { attrs: { colspan: "3" } }, [
          _c("div", { staticClass: "flex-row" }, [
            _c("span", [_vm._v(_vm._s(_vm.form.user_number))]),
            _c("button", [_vm._v("参加人员名单")]),
          ]),
        ]),
      ]),
      _c("tr", [
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("活动负责人")]),
        _c("td", { staticClass: "align-right" }, [_vm._v("活动负责人：")]),
        _c("td", { attrs: { colspan: "3" } }, [
          _vm._v(_vm._s(_vm.form.hd_head)),
        ]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [
          _vm._v("活动负责人联系电话："),
        ]),
        _c("td", { attrs: { colspan: "3" } }, [
          _vm._v(_vm._s(_vm.form.hd_phone)),
        ]),
      ]),
      _c("tr", [
        _c("th", [_vm._v("巡展，定点展示")]),
        _c("td", { staticClass: "align-right" }, [_vm._v("路线：")]),
        _c("td", { attrs: { colspan: "3" } }, [
          _c("div", { staticClass: "flex-row" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.xz_way,
                  expression: "form.xz_way",
                },
              ],
              attrs: { readonly: "", rows: "3" },
              domProps: { value: _vm.form.xz_way },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "xz_way", $event.target.value)
                },
              },
            }),
          ]),
        ]),
      ]),
      _c("tr", [
        _c("th", [_vm._v("品系")]),
        _c("td", { staticClass: "align-right" }, [_vm._v("品系：")]),
        _c("td", { attrs: { colspan: "3" } }, [
          _vm._v(_vm._s(_vm.form.strain_ss)),
        ]),
      ]),
      _c("tr", [
        _c("th", [_vm._v("参展车辆")]),
        _c("td", { staticClass: "align-right" }, [_vm._v("车辆型号及数量：")]),
        _c(
          "td",
          { attrs: { colspan: "3" } },
          _vm._l(_vm.vehicleModelList, function (item, index) {
            return _c("div", { key: index, staticClass: "car-box" }, [
              _c("span", [_vm._v("车型代码：")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: item.configname,
                    expression: "item.configname",
                  },
                ],
                attrs: { disabled: "" },
                domProps: { value: item.configname },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(item, "configname", $event.target.value)
                  },
                },
              }),
              _c("span", { staticStyle: { "padding-left": "10px" } }, [
                _vm._v("数量："),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: item.amount,
                    expression: "item.amount",
                  },
                ],
                attrs: { disabled: "" },
                domProps: { value: item.amount },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(item, "amount", $event.target.value)
                  },
                },
              }),
            ])
          }),
          0
        ),
      ]),
      _c("tr", [
        _c("th", { attrs: { rowspan: "10" } }, [_vm._v("费用预算")]),
        _c("td", { staticClass: "align-right" }, [_vm._v("会务费：")]),
        _c("td", { attrs: { colspan: "3" } }, [_vm._v(_vm._s(_vm.form.hwf))]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [_vm._v("布展费：")]),
        _c("td", { attrs: { colspan: "3" } }, [_vm._v(_vm._s(_vm.form.bzf))]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [_vm._v("场地租金：")]),
        _c("td", { attrs: { colspan: "3" } }, [_vm._v(_vm._s(_vm.form.cdzj))]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [_vm._v("油费（柴油）：")]),
        _c("td", { attrs: { colspan: "3" } }, [_vm._v(_vm._s(_vm.form.yf))]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [_vm._v("过桥过路费：")]),
        _c("td", { attrs: { colspan: "3" } }, [_vm._v(_vm._s(_vm.form.gqglf))]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [_vm._v("礼品费：")]),
        _c("td", { attrs: { colspan: "3" } }, [_vm._v(_vm._s(_vm.form.lpf))]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [_vm._v("记者劳务费：")]),
        _c("td", { attrs: { colspan: "3" } }, [_vm._v(_vm._s(_vm.form.jzlwf))]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [_vm._v("车辆保险：")]),
        _c("td", { attrs: { colspan: "3" } }, [_vm._v(_vm._s(_vm.form.clbx))]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [_vm._v("其他费用：")]),
        _c("td", { attrs: { colspan: "3" } }, [_vm._v(_vm._s(_vm.form.qtfy))]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [_vm._v("合计：")]),
        _c("td", { attrs: { colspan: "3" } }, [_vm._v(_vm._s(_vm.form.hjfy))]),
      ]),
      _c("tr", [
        _c("th", [_vm._v("备注")]),
        _c("td", { staticClass: "align-right" }, [_vm._v("备注：")]),
        _c("td", { attrs: { colspan: "3" } }, [
          _c("div", { staticClass: "flex-row" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.remark,
                  expression: "form.remark",
                },
              ],
              attrs: { readonly: "", rows: "3" },
              domProps: { value: _vm.form.remark },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "remark", $event.target.value)
                },
              },
            }),
          ]),
        ]),
      ]),
      _c("tr", [
        _c("th", { attrs: { rowspan: "3" } }, [_vm._v("附件")]),
        _c("td", { staticClass: "align-right" }, [_vm._v("活动方案：")]),
        _c("td", { attrs: { colspan: "3" } }, [
          _c("a", { attrs: { href: _vm.form.hdfa } }, [
            _vm._v(_vm._s(_vm.form.hdfa)),
          ]),
        ]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [
          _vm._v("预计拜访客户名单："),
        ]),
        _c("td", { attrs: { colspan: "3" } }, [
          _c("a", { attrs: { href: _vm.form.yjbfyh } }, [
            _vm._v(_vm._s(_vm.form.yjbfyh)),
          ]),
        ]),
      ]),
      _c("tr", [
        _c("td", { staticClass: "align-right" }, [_vm._v("其他附件：")]),
        _c("td", { attrs: { colspan: "3" } }, [
          _c("a", { attrs: { href: _vm.form.qtfj } }, [
            _vm._v(_vm._s(_vm.form.qtfj)),
          ]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticStyle: { "margin-top": "30px" } },
      [
        _c(
          "vxe-table",
          {
            attrs: {
              loading: _vm.listLoading,
              border: "",
              resizable: "",
              height: "300",
              align: _vm.allAlign,
              data: _vm.tableData,
            },
          },
          [
            _c("vxe-table-column", {
              attrs: { type: "seq", width: "60", title: "序号" },
            }),
            _c("vxe-table-column", {
              attrs: { field: "user_name", width: "200", title: "审核人" },
            }),
            _c("vxe-table-column", {
              attrs: { field: "audit_time", width: "200", title: "审核日期" },
            }),
            _c("vxe-table-column", {
              attrs: { field: "audit_idear", title: "意见" },
            }),
            _c("vxe-table-column", {
              attrs: { field: "status_name", width: "100", title: "状态" },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "note" }, [
          _vm._v(" 注：标有 * 的标识为必填项 "),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "align-right" }, [
      _c("span", [_vm._v("时间：")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }